import { withDeepApiConfig } from '@deepcloud/api-base'
import { createAPIV1 } from './v1'
import type { CreateAbaSupportHttpClientOptions } from '../types'

function createAbaSupportAPI({
  httpClient,
  ...config
}: CreateAbaSupportHttpClientOptions) {
  const abaSupportHttpClient = withDeepApiConfig(httpClient, config)

  return {
    abaSupportHttpClient,
    ...createAPIV1(abaSupportHttpClient),
  }
}

export { createAbaSupportAPI }
